import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	rightChevronLabel: {
		id: 'command-palette.common.components.command-row.right-content.right-chevron-label',
		defaultMessage: 'Command with children icon',
		description: 'Right chevron icon to indicate command has children',
	},
});
